import $ from 'jquery'
import {
  prepareChessboard,
  plotArrow,
  showCapturedPieces
} from '../../utils';
import ChessBoard from '../../components/chessBoard';

/**
* @name lesson7Assignment2
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson8Assignment2(config) {
  let offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  }

  let afterLoad = function () {
    prepareChessboard(config);


    $('#myCanvas').addClass('show').removeClass('hide');
    var c = document.getElementById("myCanvas");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);

    plotArrow(ctx, config.from, config.to, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, "#cc0000");
  }

  const chessConfig = {
    config: {
      position: config.position,
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson7Assignment3
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson8Assignment3(config) {
  let moveSpeed = 1000,
    offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  };

  let afterLoad = function () {
    prepareChessboard(config);
    $('#myCanvas').addClass('show').removeClass('hide');
    var c = document.getElementById("myCanvas");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);

    plotArrow(ctx, config.from, config.to, offsetFromx, offsetFromy, offsetTox, offsetToy);

    setTimeout(function () {
      ctx.clearRect(0, 0, c.width, c.height);
      ChessBoard.board.move(config.from.substr(7, 9) + "-" + config.to.substr(7, 9));
      if (config.capture) {
        let move = {
          captured: config.capture.capturedPiece.charAt(1),
          color: config.capture.capturingPiece.charAt(0)
        }
        setTimeout(function () {
          showCapturedPieces(config.capture.capturingPiece, move)
        }, moveSpeed)
      }
    }, 1000);
  }

  const chessConfig = {
    config: {
      position: config.position,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad,

  }
  return chessConfig;
}




// WEBPACK FOOTER //
// ./src/lessons/lesson_8/assignments.js